<template>
    <div>
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                                style="background: url('/assets/images/pexels-pixabay-Snow-Mountain2000fshead.png')  center;">
                        <h4 class="widget-user-desc text-left">To achieve 'the impossible': Open your Mind.</h4>
                        <!-- <h2 class="widget-user-username text-left">To achieve 'the impossible': First, learn.</h2> -->
                        <h3 class="widget-user-username text-right">Know the Opportunities.</h3>
                        <h3 class="widget-user-username text-right">Understand the Strategies.</h3>
                    </div>
                    <div class="widget-user-image">
                        <img class="img-circle" src="/assets/images/artist128x128.png" alt="User Avatar">
                    </div>
                </div>
            </div>
        </div>
        <div class="habit-card-sub-body d-flex mx-auto" >
            <div class="card-body">
                <div class="row d-flex justify-content-between">
                    <!-- <div class="col-4 col-sm-12" > {{coursedata.name}}</div> -->
<!-- <div class="col-12 col-sm-12" ></div> -->
                    <img class=".img-fluid mx-auto" style="width:480px;  max-width: 100%; height: auto; " :src="coursedata.image_url" >
                </div>
                <div class="row">
                    <div class="color-palette-set bordered m-2 p-4">
                        <div class="card row text-center" >
                            <div class="row .flex-row justify-content-between bg-default" style="padding:.5em;">
                                <h4 class="mx-auto" >Course Sections:</h4> <!--Course Categories, Headings.....-->
                            </div>
                        </div>
                        <div id="displayLessonCategories" v-if="courseLessonCats.length>0" >
                            <div id="accordion">
                                <div v-for="lessoncat in courseLessonCats" :key="lessoncat.id" class="card"  style="background-color:#efefef;">
                                    <div class="card-header c-header mx-2 my-2" :id="'heading'+lessoncat.id">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link collapsed" data-toggle="collapse" :data-target="'#collapse'+lessoncat.id" aria-expanded="false" :aria-controls="'collapse'+lessoncat.id">
                                            <div><h5><b> {{lessoncat.name}} </b></h5><small v-if="lessoncat.byline"><i>({{lessoncat.byline}})</i></small></div>
                                            </button>
                                        </h5>
                                    </div>
                                    <div :id="'collapse'+lessoncat.id" :class="collapseOrShow(lessoncat.id)" :aria-labelledby="'heading'+lessoncat.id" data-parent="#accordion">
                                        <div class="card-body">
                                            <!-- Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS. -->
                                            <div v-for="lesson in lessoncat.lessons" :key="lesson.id"   >
                                                <div class="citem">
                                                    <!-- lessonTitleDisplayWithStatus(lesson_name, lesson_introtext, course_id, lesson_id) -->
                                                    <!-- <a   href="#" @click="displayLessonInModal(lesson.id)" v-html="'<b>'+lesson.name + ' :</b><br/><small ><i>' + lesson.intro_text+'</i></small>'"></a> -->
                                                     <a   href="#" @click="displayLessonInModal(lesson.id)" v-html="lessonTitleDisplayWithStatus(lesson.name, lesson.intro_text, coursedata.id, lesson.id)"></a>
                                                <!-- <small style="font-size:x-small;color:brown;">{{ 'Done:' +flagAsDone(coursedata.id, lesson.id) }}</small> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> <!-- end of single lessoncat dispaly-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../event-bus';
import Editor from '@tinymce/tinymce-vue';
import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
        lessonInput: Editor,
     },
    name: "LearningCentral",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            coursedata:[],
            courseLessonCats:[],
            lessondata:[],
            trackingData:[],
            showCatChosen: false,
        }
    },

    props: {
        user:'',
        course:'',
        lessoncats:'',
        tracking:'',
    },

    mounted() {
        // console.log("ApiKey: " + this.apikey);
        this.coursedata = JSON.parse(this.course);
        this.courseLessonCats = JSON.parse(this.lessoncats);
        this.trackingData = JSON.parse(this.tracking);
        this.userinfo = JSON.parse(this.user);
    },

    methods: {
        lessonTitleDisplayWithStatus(lesson_name, lesson_introtext, course_id, lesson_id){
            var flagAsDoneTxt = this.flagAsDone(course_id, lesson_id);
            var title = `<b>`+lesson_name + ` :</b><small style="color:brown;font-size:x-small;float:right;">`+ flagAsDoneTxt + `</small><br/><small ><i>` + lesson_introtext+`</i></small>`;
            return title;
        },
        collapseOrShow(cat_id) {
            var retVal = 'collapse';
            if(!this.trackingData || this.trackingData.length < 1) retVal = 'collapse';
            if(this.trackingData || this.trackingData.length > 0) {
                if(this.showCatChosen == false) {
                    [...this.trackingData].forEach(tracking => {
                        // console.log(tracking);
                        if(this.coursedata.id == tracking.course_id && tracking.lessoncat_id == cat_id) {
                            retVal = tracking.status == 'done'? 'collapse': 'collapse show';
                            if(retVal == 'collapse show') this.showCatChosen = true;
                        }
                    });
                }
            }
            // console.log("for " + cat_id  + " returning " + retVal);
            return retVal;
        },
        flagAsDone(course_id, lesson_id) {
            var retVal = 'Not done';
            [...this.trackingData].forEach(tracking => {
                        // console.log(tracking);
                        if(course_id == tracking.course_id && tracking.lesson_id == lesson_id) {
                            retVal = tracking.status;
                        }
                    });
            return retVal;
        },
        getLessonsForCat(lessoncatid) {
            var lessons = [];
            [...this.allLessonsData].forEach(lesson=>{
                if(lesson.lesson_category_id == lessoncatid) lessons.push(lesson);
            });
            return lessons;
        },
        displayLessonInModal(lessonid) {
            EventBus.$emit('displayLesson', {'lessonid': lessonid, 'course_id': this.coursedata.id});
        },
        createLesson(lessoncatID) {
            EventBus.$emit('showNewLessonModal', {lessoncat_id: lessoncatID});
        },
        cancel() {
            // console.log("Cancel close LessonManage");
            window.location.replace('/edu/admin/courses');
        },
        getLesson(lesson_id) {
            // console.log("Looking for lesson with id " + lesson_id);
            var retVal = '';
            [...this.allLessonsData].forEach((lesson) =>{
                if(lesson.id == lesson_id) {
                    // console.log("Found lesson...");
                    retVal =  lesson;
                }
            });
            return retVal;
        },
        setCourseAssets() {
            //retrieve the selected course's lesson_categories
            this.retrieveCourseLessonCats();
            this.getSelectedCourseInfo();
        },
        createNewLesson() {
            // console.error(" lessonsmanage::cr new lesson.");
            var payload = {};
            EventBus.$emit('showNewLessonModal');
        },
        editLesson(lesson_id) {
            // var payload = {'course':  this.getLessonData(this.selcourse_id )};
            var payload = {'lessonid':  lesson_id, 'lessondata': this.getLesson(lesson_id), 'lessoncat_id': this.lessoncat_id};
            EventBus.$emit('editLessonModal', payload);
        },
        getCourseData(course_id) {
            //  console.error("looing for : " + course_id);
            var retVal = '';
            [...this.allCoursesData].forEach(course=> {
                if(course.id == course_id) {
                    // console.error("Found course...." + course.id);
                     retVal =  course;
                }
            });
            return retVal;
        },
        getSelectedCourseInfo() {
            if(this.selcourse_id != '') {
                var course = this.getCourseData(this.selcourse_id );
                return course.name + " <small>( " + course.byline + " )</small>";
            } else {
                return '';
            }
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
    color: #fff;
}
.c-header{
    background:#fff;
    color:blue;
    border-radius:1em;
    border: rgb(253, 252, 252) 3px solid;
    box-shadow: 2px 4px 4px 2px #666;

}
.citem {
    background: #fff;
    color: #333;
    border: rgb(208, 208, 208) 2px solid;
    border-radius: .5em;
    padding: 2px;
    margin: 2px;
}
</style>
